<template>
  <el-select v-model="normType" placeholder="选择指标类型">
    <el-option
      v-for="item in normTypes"
      :key="item.label"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "NormSelect",
  data() {
    return {
      normTypes: [
        {
          value: 1,
          label: "共性指标",
        },
        {
          value: 100,
          label: "个性指标",
        },
        {
          value: 200,
          label: "关键指标",
        },
        {
          value: 4000,
          label: "加减分",
        },
        {
          value: 5000,
          label: "民主测评",
        },
        {
          value: 6000,
          label: "服务对象测评",
        },
        {
          value: 7000,
          label: "党委打分",
        },
      ],
      normType: "",
    };
  },

  watch: {
    normType(newVal, oldVal) {
      this.$emit("normType", this.normType);
    },
  },
};
</script>

<style scoped lang="scss">
</style>